export default "/static/explore/52637a98b6af851089caccbad8aa8eb115d3d065/_next/static/images/logo-square-5bb1ec821602baf22bd8996504d378c7.png";